let registeredStore: any;

const getStore = () => registeredStore;

const register = (store: any) => {
  registeredStore = store;
};

export default { getStore, register };
